import { render } from "./Modal.vue?vue&type=template&id=a037fb9c"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Note\\WEB DESIGN\\NEED FILE\\PRACTICE\\VUE PROJECTS\\royal-shop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__